/* eslint-disable camelcase */
import { useEffect, useState } from 'react';
import useFilters from '../../../globalHooks/useFilters';
import { fetchReviews } from '../../../../modules/api';

const useReviews = () => {
  const [waiting, setWaiting] = useState(true);

  const [rawReviews, setRawReviews] = useState([]);

  const [reviews, setReviews] = useState([]);

  const [filters, setFilters] = useState([]);

  const [currentReview, setCurrentReview] = useState({
    title: '',
    full_review: '',
  });

  const [aito, setAitio] = useState({ link: null, image: null });

  const [header, setHeader] = useState('');

  const [activeFilter, setActiveFilter] = useState(null);

  const [currentPage, setCurrentPage] = useState(0);

  const [showFullReviewDialog, setShowFullReviewDialog] = useState(false);

  const { filterReviewTag } = useFilters(activeFilter);

  useEffect(() => {
    (async () => {
      const data = await fetchReviews();

      if (data) {
        setAitio(data.aito);

        setHeader(data.header);

        setRawReviews(data.reviews);

        setReviews(data.reviews);

        if (data.reviews) {
          setFilters(
            (() => {
              // loop through tags on each review and make an array of unique ones
              const uniqueTags = data.reviews.reduce((total, review) => {
                let newTags = [];
                newTags = review.tags.reduce((subTotal, tag) => {
                  const found =
                    total.find(({ slug }) => slug === tag.slug) ||
                    subTotal.find(({ slug }) => slug === tag.slug);

                  return !found ? [...subTotal, tag] : [...subTotal];
                }, []);

                return [...total, ...newTags];
              }, []);

              return uniqueTags;
            })()
          );
        }

        setWaiting(false);
      } else {
        throw new Error("Can't load feed");
      }
    })();
  }, []);

  useEffect(() => {
    setReviews(filterReviewTag(rawReviews));

    setCurrentPage(0);
  }, [activeFilter]);

  const expandReview = ({ title, full_review }) => {
    setCurrentReview({ title, full_review });

    setShowFullReviewDialog(true);
  };

  return {
    waiting,
    reviews,
    filters,
    currentPage,
    setCurrentPage,
    aito,
    setActiveFilter,
    activeFilter,
    header,
    showFullReviewDialog,
    setShowFullReviewDialog,
    currentReview,
    setCurrentReview,
    expandReview,
  };
};

export default useReviews;
